import React from 'react'

const Traffic = () => {
  return (
    <div>Traffic</div>
  )
}

export default Traffic